setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.localName === 'quick-buy-modal' || item.target.className === 'quick-buy-modal__content') {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300) 